import React from 'react'
import { ProjectContext } from './projectContext'

export const useProject = () => {
  const context = React.useContext(ProjectContext)

  if (context === undefined) {
    throw new Error('useProject can only be used within a Project context')
  }

  return context
}

export default useProject
